
// 描述： 资源订阅资源价格接口
// 时间： 2020 / 6 / 18
// created by zjj
// 
import request from '../request.js'

//据资源类型和资源名称查询资源 李开明
const selectResourceByCondition = function (data) {
    return request({
        url: 'resourcesPriceAh/selectResourceByCondition',
        method: 'post',
        data
    })
}
//新增资源或者编辑资源李开明
const insertOrUpdateResource = function (data) {
    return request({
        url: 'resourcesPriceAh/insertOrUpdateResource',
        method: 'post',
        data
    })
}
//条件分页查询 李开明
const selectResourcePage = function (data) {
    return request({
        url: 'resourcesPriceAh/selectResourcePage',
        method: 'post',
        data
    })
}
//删除  李开明
const deleteResource = function (data) {
    return request({
        url: 'resourcesPriceAh/deleteResource',
        method: 'post',
        data
    })
}
export {
    selectResourceByCondition,
    insertOrUpdateResource,
    selectResourcePage,
    deleteResource
}